// extracted by mini-css-extract-plugin
export var bold = "_yq-0";